// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__31V6f","contentControl":"styles_contentControl__2YXvF","modal":"styles_modal__2XgPD","loaderWrap":"styles_loaderWrap__2mgwm"};